<template>
  <div class="items main-content">
    <div class="page-header">
      <div class="d-flex flex-row">
        <div>
          <h3 class="page-title">
            {{ $tc("islamic_finance.finances_forms") }}
          </h3>
        </div>
      </div>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="dashboard">{{
            $t("general.home")
          }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">
            {{ $tc("islamic_finance.finances_forms") }}</router-link
          >
        </li>
      </ol>

      <div class="page-actions row">
        <router-link
          slot="item-title"
          class="col-xs-2"
          to="finances-forms/create"
        >
          <base-button color="theme" icon="plus" size="large">
            {{ $t("islamic_finance.add_finances_forms") }}
          </base-button>
        </router-link>
      </div>
    </div>
    <div
      v-cloak
      v-show="showEmptyScreen"
      class="col-xs-1 no-data-info"
      align="center"
    >
      <satellite-icon class="mt-5 mb-4" />
      <div class="row" align="center">
        <label class="col title">{{ $t("actions.no_action") }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{
          $t("actions.list_of_action")
        }}</label>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <!--  -->
        <p class="table-stats">
          {{ $t("general.showing") }}: <b>{{ financesForms.length }}</b>
          {{ $t("general.of") }} <b>{{ totalFinancesForms }}</b>
        </p>
      </div>
      <div class="custom-control custom-checkbox">
        <input
          id="select-all"
          v-model="selectAllFieldStatus"
          type="checkbox"
          class="custom-control-input"
          @change="selectAllFinancesForms"
        />
        <label
          v-show="!isRequestOngoing"
          for="select-all"
          class="custom-control-label selectall"
        >
          <span class="select-all-label">{{ $t("general.select_all") }} </span>
        </label>
      </div>
      <table-component
        ref="table"
        :data="fetchData"
        :show-filter="false"
        table-class="table"
      >
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-checkbox">
              <input
                :id="row.id"
                v-model="selectField"
                :value="row.id"
                type="checkbox"
                class="custom-control-input"
              />
              <label :for="row.id" class="custom-control-label" />
            </div>
          </template>
        </table-column>
        <table-column :label="$t('islamic_finance.funders')" show="user.name" />
        <table-column :label="$t('islamic_finance.forms')">
          <template slot-scope="row">
            {{ row.form_name }}
          </template>
        </table-column>
        <table-column :label="$t('actions.updated_at')" show="updated_at" />

        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <v-dropdown>
              <a slot="activator" href="#">
                <dot-icon />
              </a>
              <v-dropdown-item>
                <router-link
                  :to="{ path: `finances-forms/${row.funder_id}/view` }"
                  class="dropdown-item"
                >
                  <font-awesome-icon
                    :icon="['fas', 'pencil-alt']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.view") }}
                </router-link>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DotIcon from "../../components/icon/DotIcon";
import SatelliteIcon from "../../components/icon/SatelliteIcon";
import BaseButton from "../../../js/components/base/BaseButton";

export default {
  components: {
    DotIcon,
    SatelliteIcon,
    BaseButton
  },
  data() {
    return {
      id: null,
      showFilters: false,
      isRequestOngoing: true,
      filtersApplied: false,
      forms: [
        {
          id: 1,
          name: "Offer Sent",
          label: "offer_sent"
        },
        {
          id: 2,
          name: "Offer Accepted",
          label: "offer_accepted"
        },
        { id: 3, name: "Notice of Delivery", label: "notice_of_delivery" },
        {
          id: 4,
          name: "Documentation Complete",
          label: "documentation_complete"
        },
        {
          id: 5,
          name: "Confirmation of Sale",
          label: "confirmation_of_sale"
        }
      ]
    };
  },

  computed: {
    ...mapGetters("financesForms", [
      "financesForms",
      "totalFinancesForms",
      "selectAllField"
      // 'selectedEmailActions'
    ]),
    showEmptyScreen() {
      return (
        !this.financesForms && !this.isRequestOngoing && !this.filtersApplied
      );
    },
    filterIcon() {
      return this.showFilters ? "times" : "filter";
    },
    selectField: {
      get: function() {
        // return this.selectedEmailActions
      },
      set: function(val) {
        this.selectEmailAction(val);
      }
    },
    selectAllFieldStatus: {
      get: function() {
        return this.selectAllField;
      },
      set: function(val) {
        // this.setSelectAllState(val)
      }
    }
  },

  watch: {
    filters: {
      handler: "setFilters",
      deep: true
    }
  },
  created() {},
  destroyed() {
    if (this.selectAllField) {
      this.selectAllFinancesForms();
    }
  },
  methods: {
    ...mapActions("financesForms", [
      "fetchFinancesForms",
      "selectAllFinancesForms"
      // 'deleteFinancesForm',
      // 'setSelectAllState'
    ]),
    // ...mapActions('modal', [
    //   'openModal'
    // ]),
    refreshTable() {
      this.$refs.table.refresh();
    },
    async fetchData({ page, per_page, filter, sort }) {
      this.isRequestOngoing = true;
      let response = await this.fetchFinancesForms({ page, per_page });
      this.isRequestOngoing = false;

      return {
        data: response.data.financesForms.data,
        pagination: {
          totalPages: response.data.financesForms.last_page,
          currentPage: page,
          rowsPerPage: per_page // Add rowsPerPage in the API request
        }
      };
    },
    // async deleteFinances(id) {
    //   let res = await this.deleteFinancesForm(id)
    //   if (res.data.success) {
    //     window.toastr['success'](this.$tc('islamic_finance.delete_content'))
    //     this.refreshTable()
    //     return true
    //   }
    // },
    setFilters() {
      this.filtersApplied = true;
      // this.refreshTable()
    },
    // clearFilter () {
    //   this.filters = {
    //     name: '',
    //     part_number: '',
    //     unit: '',
    //     price: ''
    //   }

    //   this.$nextTick(() => {
    //     this.filtersApplied = false
    //   })
    // },
    toggleFilter() {
      if (this.showFilters && this.filtersApplied) {
        // this.clearFilter()
        // this.refreshTable()
      }
      this.showFilters = !this.showFilters;
    },
    getFormType(type) {
      var formName = this.forms.filter(function(item) {
        return item.label.indexOf(type) > -1;
      });

      if (formName.length > 0) {
        return formName[0].name;
      }
    }
  }
};
</script>
